// extracted by mini-css-extract-plugin
export default {"box":"sscard_box__nEZtB","img_box":"sscard_img_box__Bse35","title1":"sscard_title1__-2+4J","title2":"sscard_title2__A2pwL"};